import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ProductList from 'Component/ProductList';
import ProductListQuery from 'Query/ProductList.query';
import { updateNoMatch } from 'Store/NoMatch/NoMatch.action';
import { showNotification } from 'Store/Notification/Notification.action';
import { MixType } from 'Type/Common.type';
import { getIndexedProducts } from 'Util/Product';
import { prepareQuery } from 'Util/Query';
import { executeGet } from 'Util/Request';
import DataContainer from 'Util/Request/DataContainer';

import './ProductListBySkus.style';

/** @namespace PeggysagePwa/Component/ProductListBySkus/Container/mapStateToProps */
export const mapStateToProps = () => ({
    // ...
});

/** @namespace PeggysagePwa/Component/ProductListBySkus/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({
    updateNoMatch,
    showNotification
});

/** @namespace PeggysagePwa/Component/ProductListBySkus/Container */
export class ProductListBySkusContainer extends DataContainer {
    static propTypes = {
        showPager: PropTypes.number,
        productsCount: PropTypes.number,
        productsPerPage: PropTypes.number,
        productsSkuArray: PropTypes.arrayOf(PropTypes.string).isRequired,
        mix: MixType,
        updateNoMatch: PropTypes.func.isRequired,
        showNotification: PropTypes.func.isRequired,
        title: PropTypes.string,
        cacheLifetime: PropTypes.number
    };

    static defaultProps = {
        showPager: 0,
        productsCount: 10,
        productsPerPage: 6,
        mix: {},
        title: '',
        cacheLifetime: 86400
    };

    state = {
        pages: {},
        totalItems: 0,
        totalPages: 0,
        isLoading: true
    };

    containerFunctions = {
        requestProductList: this.requestProductList.bind(this),
        updateLoadStatus: this.updateLoadStatus.bind(this)
    };

    onError = this.onError.bind(this);

    appendPage = this.appendPage.bind(this);

    updateProductListItems = this.updateProductListItems.bind(this);

    // dataModelName = 'ProductListWidget';

    containerProps() {
        const {
            // currentPage,
            // device,
            // isShowLoading,
            // isVisible,
            // loadPrevPage,
            // requestPage,
            // selectedFilters,
            title,
            mix
            // updatePage
        } = this.props;
        const {
            pages,
            totalItems,
            totalPages,
            isLoading
        } = this.state;

        return {
            // currentPage,
            // device,
            // isShowLoading,
            // isVisible,
            // loadPrevPage,
            // requestPage,
            // selectedFilters,
            title,
            mix,
            // updatePage,
            pages,
            totalItems,
            totalPages,
            isLoading,
            ...this.adaptProps()
        };
    }

    onError(error) {
        const { showNotification, updateNoMatch } = this.props;
        showNotification('error', __('Error fetching Product List!'), error);
        updateNoMatch(true);
    }

    appendPage(data) {
        const { showPager } = this.props;
        const { pages } = this.state;
        const {
            products: {
                items,
                page_info: { current_page } = {}
            } = {}
        } = data;

        if (showPager === 0) {
            return;
        }

        this.setState({
            pages: {
                ...pages,
                [current_page]: getIndexedProducts(items)
            }
        });
    }

    updateProductListItems(data) {
        const { productsCount, productsPerPage } = this.props;
        const {
            products: {
                items,
                total_count: totalItems,
                page_info: { current_page } = {}
            } = {}
        } = data;

        const totalPages = Math.ceil(productsCount / productsPerPage);

        this.setState({
            isLoading: false,
            totalItems,
            totalPages,
            pages: { [current_page]: getIndexedProducts(items) }
        });
    }

    updateLoadStatus(isLoading) {
        this.setState({ isLoading });
    }

    requestProductList(options) {
        const { isNext } = options;
        const { cacheLifetime } = this.props;

        if (!isNext) {
            this.updateLoadStatus(true);
        }

        // this.fetchData(
        //     [ProductListQuery.getQuery(options)],
        //     isNext ? this.appendPage : this.updateProductListItems,
        //     this.onError
        // );

        const query = [ProductListQuery.getQuery(options)];
        executeGet(prepareQuery(query), 'NewProducts', cacheLifetime)
            .then(
                /** @namespace PeggysagePwa/Component/ProductListBySkus/Container/ProductListBySkusContainer/requestProducts/then/catch/executeGet/then */
                // ({ products: { items } }) => this.setState({ products: getIndexedProducts(items) })
                isNext ? this.appendPage : this.updateProductListItems,
            )
            .catch(
                /** @namespace PeggysagePwa/Component/ProductListBySkus/Container/ProductListBySkusContainer/requestProducts/then/catch/showNotification */
                // (e) => showNotification('error', __('Error fetching NewProducts!'), e)
                this.onError
            );
    }

    adaptProps() {
        const {
            showPager,
            productsCount,
            productsPerPage,
            productsSkuArray
        } = this.props;

        return {
            filter: { productsSkuArray },
            pageSize: showPager ? productsPerPage : productsCount,
            isPaginationEnabled: !!showPager
        };
    }

    render() {
        const { mix } = this.props;

        return (
            <ProductList
              { ...this.containerProps() }
              { ...this.containerFunctions }
              isInfiniteLoaderEnabled={ false }
              numberOfPlaceholders={ 4 }
              mix={ { block: 'ProductListWidget', mix } }
              isWidget
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductListBySkusContainer);
